import React from 'react';
import './StatsBar.css';

const stats = [
  { num: '50+', label: 'Project Installations' },
  { num: '10MW+', label: 'Project Installed' },
  { num: '100MW', label: 'BESS Projects' },
  { num: '5★', label: 'Google Rating' },
];

const StatsBar = () => {
  return (
    <div className="stats-bar">
      {stats.map((stat, i) => (
        <div className="stats-bar__item" key={i}>
          <span className="stats-bar__num">{stat.num}</span>
          <span className="stats-bar__label">{stat.label}</span>
        </div>
      ))}
    </div>
  );
};

export default StatsBar;
